<template>
  <div class="news-list">
    <top-bar></top-bar>
    <mobile-nav v-if="isMobile" :edu="edu" :space="space"></mobile-nav>
    <nav-bar :edu="edu" :space="space"></nav-bar>
    <search-bar ref="searchBar" @search="search"></search-bar>
    <mobile-breadcrumb v-if="isMobile"></mobile-breadcrumb>
    <div class="info-list-container">
      <info-list ref="infoList" @getStr="getStr" :isMobile="isMobile"></info-list>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import TopBar from '@/components/TopBar.vue'
import NavBar from '@/components/NavBar.vue'
import SearchBar from '@/components/SearchBar.vue'
import InfoList from '@/components/InfoList.vue'
import Footer from '@/components/Footer.vue'
import MobileBreadcrumb from '@/components/MobileBreadcrumb.vue'
import MobileNav from '@/components/MobileNav.vue'

export default {
  name: 'NewsList',
  computed: {
    isMobile () {
      return /Android|Windows Phone|iPhone|iPod/i.test(navigator.userAgent)
    }
  },
  components: {
    MobileNav,
    TopBar,
    NavBar,
    SearchBar,
    InfoList,
    Footer,
    MobileBreadcrumb
  },
  data () {
    return {
      edu: [],
      space: []
    }
  },
  created () {
    this.$nextTick(() => {
      const typeObj = JSON.parse(window.localStorage.getItem('typeObj'))
      this.edu = typeObj.edu
      this.space = typeObj.space
    })
  },
  methods: {
    search (word) {
      this.$refs.infoList.changeKeyword(word)
    },
    getStr (str) {
      this.$refs.searchBar.getStr(str)
    }
  }
}
</script>

<style lang="scss" scoped>
.info-list-container {
  margin-top: 50px;
}
</style>
